import React, { FC, useEffect } from 'react';
import { Button, ButtonProps, KIND } from 'baseui/button';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const BackButton: FC<ButtonProps> = ({
                                                size = 'compact',
                                                kind = KIND.secondary,
                                                ...rest
                                            }) => {
    const { goBack: back, go } = useHistory();
    const [t] = useTranslation();
    const goBack = () => {
        let count = (parseInt(window.sessionStorage.getItem("backCount") || "") || 0)
        if(count > 0) {
            go(count * -1)
        } else {
            back()
        }
    }
    return (
        <Button
            {...rest}
            onClick={() => goBack()}
            size={size}
            kind={kind}
        >
            {t('Wróć')}
        </Button>
    );
};

export const BackCountHelper = () => {
    const location = useLocation()

    useEffect(() => {
        window.sessionStorage.removeItem("backCount")
    }, [location.pathname])
        
    useEffect(() => {
        let count = (parseInt(window.sessionStorage.getItem("backCount") || "") || 0) + 1
        window.sessionStorage.setItem("backCount", `${count}`)
    }, [location.search])

    return null
}